import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ClientAccessRightsResolverErrorStatesEnum {
    GetClientFailed = ErrorStateScheduleEnum.ClientAccessRightsResolverErrorStatesStartIndex,
    NonActiveClient,
    GetUserWithPermissionsFailed,
    GetPortalPermissionsFailed,
    GetPortalPermissionsNoData,
    GetAssignedAccountsRightsFailed,
    GetSupervisedRightsFailed
}
